import React, { useState, useEffect } from "react";
import noImage from "../../assets/images/material/noimage.jpg";

const threthold = 640;

export const Image = (props) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [isSmallImageAvailable, setIsSmallImageAvailable] = useState(true);

  useEffect(() => {
    if (props.src != null && !props.noSmall) {
      const smallSrc = window.innerWidth >= threthold ? src : smallUrl(src);
      const img = document.createElement("img");
      img.onload = () => {
        setImageSrc(smallSrc);
        setIsSmallImageAvailable(true);
      };
      // 圧縮画像がない場合は通常サイズの画像も試す
      img.onerror = () => {
        const normalImg = document.createElement("img");
        // 通常サイズの画像がある場合は通常サイズの画像を表示
        normalImg.onload = () => {
          setImageSrc(src);
          setIsSmallImageAvailable(false);
        };
        // 通常サイズの画像がない場合はnoImageを表示
        normalImg.onerror = () => {
          setImageSrc(noImage);
          setIsSmallImageAvailable(false);
        };
        normalImg.src = src;
      };
      img.src = smallSrc;
    } else if (props.src != null) {
      // 通常サイズの画像のみを試す
      const normalImg = document.createElement("img");
      normalImg.onload = () => {
        setImageSrc(src);
      };
      normalImg.onerror = () => {
        setImageSrc(noImage);
      };
      normalImg.src = src;
    } else {
      setImageSrc(noImage);
    }
  }, [props.src, props.noSmall]);

  var style = props.style ? props.style : {};
  if (props.color != null) {
    style.backgroundColor = props.color;
  }

  var src;
  if (props.src == null) {
    src = noImage;
  } else {
    src = imageUrl(props.src);
  }

  if (props.src != null && props.full) {
    var altSrc = fullUrl(src);
    return (
      <span className="uk-display-inline-block uk-position-relative">
        <img
          style={style}
          className={props.className}
          onClick={props.onClick}
          src={imageSrc || src}
          alt={props.alt}
        />
        {window.innerWidth >= threthold && (
          <img
            className="uk-position-center uk-position-z-index"
            src={altSrc}
            alt={props.alt}
          />
        )}
      </span>
    );
  }
  return (
    <img
      style={style}
      className={props.className}
      onClick={props.onClick}
      src={imageSrc || src}
      alt={props.alt}
    />
  );
};

export const FirstImage = (props) => {
  const src =
    props.srcs && props.srcs.length > 0 ? props.finder(props.srcs[0]) : null;
  return <Image {...props} src={src} />;
};

export const imageUrl = (url) => {
  if (url == null) {
    return null;
  }
  return process.env.REACT_APP_STORAGE_PREFIX + "/" + url;
};

export const fullUrl = (url) => {
  const array = url.split(".");
  return array
    .map((path, index) => {
      return index != array.length - 2 ? path : path + "@full";
    })
    .join(".");
};

export const smallUrl = (url) => {
  const array = url.split(".");
  return array
    .map((path, index) => {
      return index != array.length - 2 ? path : path + "@small";
    })
    .join(".");
};
